import { MapStyle } from "./googlemapstyle";
import { env } from "./env";

// API Base URL
export const API_BASE_URL = env.apiBaseUrl;

// Token Storage
export const AUTH_TOKEN_KEY = 'authToken';
export const SECRET_ENCRYPTION_KEY = env.secretEncryptionKey;
export const GOOGLE_MAPS_API_KEY = env.googleMapsApiKey;

// User roles 
export const ROLE_KEY = 'role';

export const ROLES = {
  ADMIN: 'admin',
  ASSISTANT_ADMIN: 'assistant_admin',
  ORGANIZER: 'organizer',
  PARENT: 'parent',
  CHILD: 'child',
};

export const ROLE_LABELS = {
  admin: 'Management Admin',
  assistant_admin: 'Support Admin',
  organizer: 'Organizer',
};

// Other constants
export const APP_NAME = 'Popout';
export const DEFAULT_THEME = 'light';
export const CURRENCY_CODE = ' AED';

export const WALK_STATUS = {
  REQUESTED: 'requested',
  FINDING_WALKER: 'finding_walker',
  WALKER_ASSIGNED: 'walker_assigned',
  HEADING_TO_PICKUP: 'heading_to_pickup',
  PICKED_UP: 'picked_up',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

export const DELIVERY_STATUS = {
  REQUESTED: 'requested',
  FINDING: 'finding_driver',
  ASSIGNED: 'driver_assigned',
  HEADING_TO_PICKUP: 'heading_to_pickup',
  PICKUP_ARRIVED: 'arrived_at_pickup',
  EN_ROUTE_TO_DROPOFF: 'en_route_to_dropoff',
  DROPOFF_ARRIVED: 'arrived_at_dropoff',
  EN_ROUTE_RETURN: 'en_route_to_return',
  RETURN_ARRIVED: 'arrived_at_return',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};



export const GoogleMapStyle = MapStyle